<template>
  <span>
    <v-fade-transition mode="out-in">
      <v-card class="elevation-3 hidden-sm-and-down" style="width: 85%">
        <router-link :to="'/service/'+ service.slug">
          <v-img  height="180" :src="getSinImage(service.image)" :lazy-src="getSinImage(service.image)" class="white--text">
            <v-card-title 
              style="font-size: 15px; word-break: normal; line-height: 1.0;"
              class="subtitle-1 font-weight-bold">
              {{ service.name | capitalize }}
            </v-card-title>
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </router-link>
        <v-rating :value="3.5" color="amber" half-increments dense size="18" readonly class="pad"></v-rating>
        <div class="grey--text ml-2">3.5 (41)</div>
        <div class="font-weight-bold" style="height: 40px; line-height: 1.0;">
          <a class="pad">
            {{service.client | capitalize}} |<br> 
            <b>{{ service.SubCat_slug }}</b>
          </a>
        </div>
      </v-card>
    </v-fade-transition>
    <v-fade-transition mode="out-in">
      <v-card class="elevation-3 hidden-md-and-up"  style="width: 85%">
        <router-link :to="'/service/'+ service.slug">
          <v-img  height="130" :src="getSinImage(service.image)"
            :lazy-src="getSinImage(service.image)" class="white--text">
            <v-card-title 
              style="font-size: 15px; word-break: normal; line-height: 1.0;"
              class="subtitle-1 font-weight-bold">
              {{ service.name | capitalize }}
            </v-card-title>
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </router-link>
        <v-rating :value="3.5" color="amber" half-increments dense size="18" readonly class="pad"></v-rating>
        <div class="black--text ml-2">3.5 (41)</div>
        <div class="font-weight-bold" style="height: 40px; line-height: 1.0;">
          <a class="pad">
            {{service.client | capitalize}} | 
            <b>{{ service.SubCat_slug }}</b>
          </a>
        </div>
      </v-card>
    </v-fade-transition>
  </span>
</template>

<script>
	import {fb} from '@/firebase'
  export default {
    props: {
      service: {
        required: true,
        type: Object
      }
    },
    created(){
      this.uid = fb.auth().currentUser.uid
    },
    methods: {
      getSinImage(image){
        return image[0]
      },

      goToSignIn(){
        this.$router.push('/signin')
      }
    },

    computed: {
      userIsAuthenticated () {
        return this.uid !== null && this.uid !== undefined
      }
    }
  }
</script>

<style type="text/css" scoped>
  .pad {
    padding-left: 5px;
  }
</style>
